// extracted by mini-css-extract-plugin
export default {"wrapper":"sr-only-module--wrapper--d2cc7"};